import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { getImage, withArtDirection } from 'gatsby-plugin-image';

import { Wrapper, CropableGatsbyImage, H1, SubH1, Content } from './styled';

export const Hero = () => {
  const imagesData = useStaticQuery(graphql`
    {
      heroLg: file(relativePath: { eq: "hero-lg.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            quality: 95
            layout: CONSTRAINED
            placeholder: TRACED_SVG
          )
        }
      }
      heroMd: file(relativePath: { eq: "hero-md.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            quality: 95
            layout: CONSTRAINED
            placeholder: TRACED_SVG
          )
        }
      }
      heroSm: file(relativePath: { eq: "hero-sm.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            quality: 95
            layout: CONSTRAINED
            placeholder: TRACED_SVG
          )
        }
      }
    }
  `);
  const images = withArtDirection(getImage(imagesData.heroLg), [
    {
      media: '(max-width: 375px)',
      image: getImage(imagesData.heroSm),
    },
    {
      media: '(max-width: 768px)',
      image: getImage(imagesData.heroMd),
    },
  ]);

  return (
    <Wrapper>
      <CropableGatsbyImage image={images} alt="hero" />
      <Content>
        <H1>Your feedback means a lot to us!</H1>
        <SubH1>
          Welcome! Thank you for your recent order with us. We hope you are
          happy with your purchase. To ensure you received the very best service
          from us, and continue to do so, we would love to hear your feedback.
        </SubH1>
      </Content>
    </Wrapper>
  );
};
